<template>
  <footer class="footer">
    <div class="container-fluid d-flex flex-wrap justify-content-between">
      <nav>
        <ul class="footer-menu">
          <li>
            <router-link :to="{path:'/admin'}">Dashboard Bikes Center SA</router-link>
          </li>
        </ul>
      </nav>
      <div class="copyright">
        &copy; Bikes Center SA by Guillaume R.
      </div>
    </div>
  </footer>
</template>
<script>
  export default {}

</script>
<style>

</style>
